import { Box, Button, TextField } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ShowOnlyActivesCheckbox } from "@/controls/filters/ShowOnlyActivesCheckbox";
import { ProductTypeSelector } from "./ProductTypeSelector";

interface ProductsToolbarProps {
	search: string;
	onSearchChange: (value: string) => void;
	productTypeId: number | null;
	onProductTypeChange: (value: number | null) => void;
	onlyActives: boolean;
	onOnlyActivesChange: (value: boolean) => void;
	onAdd: () => void;
}

export const ProductsToolbar = ({
	search,
	onSearchChange,
	productTypeId,
	onProductTypeChange,
	onlyActives,
	onOnlyActivesChange,
	onAdd,
}: ProductsToolbarProps) => {
	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: 1,
				flexWrap: "wrap",
				px: 1.5,
				py: 0.5,
			}}
		>
			<TextField
				size="small"
				placeholder="Search..."
				value={search}
				onChange={(e) => onSearchChange(e.target.value)}
				sx={{ width: 200 }}
			/>

			<ProductTypeSelector
				value={productTypeId}
				onChange={onProductTypeChange}
				includeAll
				sx={{ width: 190 }}
			/>

			<ShowOnlyActivesCheckbox
				checked={onlyActives}
				onChange={onOnlyActivesChange}
			/>

			<Box sx={{ flex: 1 }} />

			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAdd}
				size="small"
			>
				ADD PRODUCT
			</Button>
		</Box>
	);
};
